// Shared message alert component for settings
import React, { useEffect } from "react";

const SettingsMessage = ({ message, onClear }) => {
  useEffect(() => {
    if (message.text && message.type === "success") {
      const timer = setTimeout(() => {
        if (onClear) onClear();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message, onClear]);

  if (!message.text) return null;

  const bgColor = message.type === "success" ? "#d1fae5" : "#fee2e2";
  const textColor = message.type === "success" ? "#065f46" : "#991b1b";
  const icon = message.type === "success" ? "✓" : "✕";

  return (
    <div
      style={{
        background: bgColor,
        color: textColor,
        padding: "12px 16px",
        borderRadius: "8px",
        marginBottom: "24px",
        fontSize: "14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <span>
        <strong>{icon}</strong> {message.text}
      </span>
      {onClear && (
        <button
          onClick={onClear}
          style={{
            background: "none",
            border: "none",
            color: textColor,
            cursor: "pointer",
            fontSize: "16px",
            padding: "0 4px",
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default SettingsMessage;
